import { render, staticRenderFns } from "./PaymentHubTable.vue?vue&type=template&id=6f496679&scoped=true"
import script from "./PaymentHubTable.vue?vue&type=script&lang=js"
export * from "./PaymentHubTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentHubTable.vue?vue&type=style&index=0&id=6f496679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f496679",
  null
  
)

export default component.exports